import { BasePage } from '@/components/ui/base-page'

export function EnergyFarmsPage() {
  return (
    <BasePage
      title="Energy Farms"
      description="Franchised energy farms — financing and solutions for energy-focused ventures."
    >
      <div className="prose dark:prose-invert max-w-none">
        <p>Our energy farms franchise offering supports development and financing of energy-focused projects. Content can be expanded here.</p>
      </div>
    </BasePage>
  )
}
